'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.KeypadController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _backspaceLeft = require('./templates/backspace-left.html');

var _backspaceLeft2 = _interopRequireDefault(_backspaceLeft);

var _backspaceRight = require('./templates/backspace-right.html');

var _backspaceRight2 = _interopRequireDefault(_backspaceRight);

var _submitLeft = require('./templates/submit-left.html');

var _submitLeft2 = _interopRequireDefault(_submitLeft);

var _submitRight = require('./templates/submit-right.html');

var _submitRight2 = _interopRequireDefault(_submitRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KeypadController = exports.KeypadController = function () {
    function KeypadController($rootScope, $templateCache, bcKeypadConfig) {
        'ngInject';

        _classCallCheck(this, KeypadController);

        this.$rootScope = $rootScope;
        this.$templateCache = $templateCache;
        this.bcKeypadConfig = bcKeypadConfig;

        this._activate();
    }

    _createClass(KeypadController, [{
        key: '_activate',
        value: function _activate() {
            // If anything other than a string was bound, overwrite with an empty string
            if (!angular.isString(this.bcNumberModel)) {
                this.bcNumberModel = '';
            }

            this.templates = {
                backspaceRight: _backspaceRight2.default,
                backspaceLeft: _backspaceLeft2.default,
                submitRight: _submitRight2.default,
                submitLeft: _submitLeft2.default
            };

            // The numbers that make up the keypad
            this.numbers = this.bcKeypadConfig.numbers.slice();

            // Pull the last number off of the array so that we can inject it outside of the ng-repeat
            this.lastNumber = this.numbers.splice(this.numbers.length - 1, 1)[0];

            // Set the max length
            this.bcMaxLength = this.bcMaxLength || this.bcKeypadConfig.maxLength;

            this._setCustomTemplates();
        }

        /**
         * Add the selected number to the number string
         *
         * @param {String} number
         */

    }, {
        key: 'setNumber',
        value: function setNumber(number) {
            // If a max length is defined, verify we have not yet reached it
            if (!this.bcMaxLength || this.bcNumberModel.length < this.bcMaxLength) {
                this.bcNumberModel += number;
            }
        }

        /**
         * Delete the last number from the number model
         */

    }, {
        key: 'backspace',
        value: function backspace() {
            // If at least one number exists
            if (this.bcNumberModel.length > 0) {
                this.bcNumberModel = this.bcNumberModel.substring(0, this.bcNumberModel.length - 1);
            } else {
                // If backspace was hit when the model is already empty
                this.bcEmptyBackspaceMethod();
            }
        }

        /**
         * Actions for the LEFT button
         *
         * @param {Object} $event
         * @param {String} type
         */

    }, {
        key: 'leftButtonTrigger',
        value: function leftButtonTrigger($event, type) {
            if (type && type === 'backspace') {
                this.backspace();
            }

            // Call the bound method
            this.bcLeftButtonMethod({ '$event': $event, 'numbers': this.bcNumberModel });
        }

        /**
         * Actions for the RIGHT button
         *
         * @param {Object} $event
         * @param {String} type
         */

    }, {
        key: 'rightButtonTrigger',
        value: function rightButtonTrigger($event, type) {
            if (type && type === 'backspace') {
                this.backspace();
            }

            // Call the bound method
            this.bcRightButtonMethod({ '$event': $event, 'numbers': this.bcNumberModel });
        }

        /**
         * Determine the correct template for the left button
         *
         * @param {String} side
         * @return {String} template
         */

    }, {
        key: 'keyTemplate',
        value: function keyTemplate(type, side) {
            // If the button type matches one of the plug'n'play types
            if (this.bcKeypadConfig.types.indexOf(type) >= 0) {
                return this.templates[type + side];
            } else {
                return;
            }
        }

        /**
         * Overwrite templates if any custom templates were set in the provider
         */

    }, {
        key: '_setCustomTemplates',
        value: function _setCustomTemplates() {

            if (this.bcKeypadConfig.customSubmitTemplate) {
                var path = this.bcKeypadConfig.submitTemplate;
                this.$templateCache.put(path, this.bcKeypadConfig.customSubmitTemplate);
            }

            if (this.bcKeypadConfig.customBackspaceTemplate) {
                var _path = this.bcKeypadConfig.backspaceTemplate;
                this.$templateCache.put(_path, this.bcKeypadConfig.customBackspaceTemplate);
            }
        }
    }]);

    return KeypadController;
}();


/** WEBPACK FOOTER **
 ** ./src/keypad.controller.js
 **/